import React, {useState} from 'react';
import LoadingButton from "../../base/components/loadingButton";
import _ from "lodash";
import axios from "../../../helpers/axios";

const PaintedButton = ({data}) => {
  const [loading,setLoading] = useState(false)

  const paintGroup = () =>{
    setLoading(true)
    const addData = (array, addedArray,sheets) =>{
      const sorted = _.groupBy(array,'sheetTitle')
      Object.keys(sorted).forEach(title=>{
        sheets.push(title)
        addedArray.push({
          sheetTitle:title,
          indexes: sorted[title].map(i=>(i.index))
        })
      })
    }
    if(data){
      const sheets = []
      let forTriTrista = []
      const sendData = {
        spreadsheetId: data.group.googleSheetId,
        kayarMissing:[],
        diff: [],
        registerDuplicates: [],
        unrecognized: [],
        triTrista: [],
        wrongList:[]
      }
      Object.keys(data.data).forEach(key=>{
        if(!!sendData[key]){
          const arrayItems = key === 'registerDuplicates' ? data.data[key].flat(Infinity) : data.data[key]
          addData(arrayItems, sendData[key],sheets)
        }
        if(key !== 'registerMissing'){
          const onlyTriTrista = _.filter(data.data[key], r=>Math.floor(r.krsTotal) === 3300)
          forTriTrista = forTriTrista.concat(onlyTriTrista)

        }
      })
      addData(forTriTrista, sendData.triTrista, sheets)
      sendData.sheets = _.uniq(sheets)
      console.log('sendData',sendData)
      if(window.confirm('Вы хотите перекрасить таблицу? вся прошлая покраска сотрется')){
        axios.post('/api/racoon/revise/group/paintGroup', sendData)
          .then(()=>{
            window.alert('Ряды успешно перекрашены')
          })
          .finally(()=>setLoading(false))
      }
    }
  }
  return (
    <LoadingButton title={'Перекрасить'}
                   loading={loading}
                   type={'button'}
                   onClick={paintGroup}
                   size={'sm'}
                   variant={'outline-secondary'}/>
  );
};

export default PaintedButton;
